// Enums
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
// Types
import { AppStateContextType } from 'contexts/types/app.contexts.type';

const isPaymentLandingPage = (currentState: AppStateContextType): boolean =>
  currentState === AppStatesEnumeration.CHECKOUT_DOWNPAYMENT;

export { isPaymentLandingPage };
